import React from "react";
import { cn } from "../../utils";

export type ContentSlot = {
  content?: React.ReactNode;
  icon?: React.ReactNode;
  wrapperProps?: React.ComponentProps<"div">;
};

export type StatusContentSlotProps = ContentSlot & {
  defaultWrapperProps?: React.ComponentProps<"div">;
  defaultIcon?: React.ReactNode;
};

const StatusContentSlot = ({
  content,
  icon,
  wrapperProps = {},
  defaultWrapperProps,
  defaultIcon
}: StatusContentSlotProps) => {
  if (!content && !icon && !defaultIcon) return null;

  const mergedProps: React.ComponentProps<"div"> = {
    ...defaultWrapperProps,
    ...wrapperProps,
    className: cn(defaultWrapperProps?.className, wrapperProps?.className)
  };

  return (
    <div {...mergedProps}>
      {icon ?? defaultIcon}
      {content}
    </div>
  );
};

export default React.memo(StatusContentSlot);
